<template>
    <div>
    <Modal
        class-name="vertical-center-modal"
        :value="showSetModel"
        :title="$t('edit')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'1000px','max-height':'800px'}">
        
        <Form ref="formDynamic" :model="formDynamic" :rules="ruleCustom" :label-width="80" >

             <div v-for="(item, index) in formDynamic.items" :key="index">
                <div style="display:flex;jutifyContent:flex-start;flex-wrap:wrap" >

                    <!--key5:'wordId',  key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey',ke6:'pageId_wordId' -->
               
                    <!-- <FormItem   v-if="languageKey.key3"  :label="$t(`BasicProduct.funcBox.titleName.${languageKey.key3}`)"  :prop="'items.' + index + '.'+languageKey.key3"  style="width:370px"
                         :rules="{required: true, message: languageKey.key3 + item.index +' can not be empty', trigger: 'change'}">
                        <Select :value="item[languageKey.key5]" @on-change="setSelectVal($event,item.index)" label-in-value clearable filterable :loading='wordListLoading'>
                          <Option v-for="(sitem,sindex) in wordList" :value="sitem.id+''" :key="sindex">{{sitem.wordCode}}</Option>
                        </Select>
                    </FormItem> -->

                    <FormItem   v-if="languageKey.key1"  :label="$t(`BasicProduct.funcBox.titleName.${languageKey.key1}`)" style="width:370px">
                        <Input type="text" disabled :value="item[languageKey.key1]" :title="item[languageKey.key1]" :placeholder="$t(`BasicProduct.funcBox.titleName.placeholderWord`)"></Input>
                          
                    </FormItem>
                    
                    <FormItem   v-if="languageKey.key4"  :label="$t(`BasicProduct.funcBox.titleName.${languageKey.key4}`)" style="width:370px">
                        <Input type="text" disabled :value="item[languageKey.key4]" :title="item[languageKey.key1]" :placeholder="$t(`BasicProduct.funcBox.titleName.placeholderWord`)"></Input>
                          
                    </FormItem>

      
                    <FormItem   v-if="languageKey.key2"  :label="'Code'"  :prop="'items.' + index + '.'+languageKey.key2"  style="width:370px"
                         :rules="{required: true, message: languageKey.key2 + item.index +' can not be empty', trigger: 'blur'}">
                        <div type="text" style="border: 1px solid #dcdee2;padding: 0px 7px;border-radius: 4px;">{{item[languageKey.key2]}}</div>
                          
                    </FormItem>
   
                </div>
                 

             </div>

            
            <FormItem v-if="isGener">
                <Button type="primary" @click="cancel">{{$t("cancel")}}</Button>
            </FormItem>

            <FormItem v-else>
                <Button type="primary" @click="handleSubmit('formDynamic')">{{$t("save")}}</Button>
                <Button @click="handleReset('formDynamic')" style="margin-left: 8px">{{$t("reset")}}</Button>
            </FormItem>

        </Form>

    </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import SearchSelect from '@/views/common/selectList.vue';  //20220415
import { mapState } from 'vuex'

    export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            languageKey:Object,
            DataType:String,
            initdata:[Array ,Object],
            pageId:Number,
            isGener:{
                type:Boolean,
                default:false
            }
        },
        name: "Model7",
       
        data() {
            return {   
                disabled: false,//禁用确定按钮
                pagesIdListUrl: this.config.urlArray.pagesLangDictionaryList,//对应pageId的词条列表
                title: '设置',//弹框标题
                formData: {//表单数据
                   
                }, 
                index: 1,
                formDynamic: {
                    items: [
                        {},{}
                    ],
                },
                descText:'',
                wordList:[],
                wordListLoading:false
               
            }
        },
        components:{
            SearchSelect
        },
        computed:{
            ...mapState(['local','selectId']),
             ruleCustom(){
                 return {//验证
                }
             } 

        },
        created(){
           
        },
        methods: {
            setSelectVal(e,index){
                let selItem = {};
                if(e){
                    this.wordList.forEach((sitem)=>{
                        if(sitem.id == e.value){
                            selItem = sitem
                        }
                    });
                    (this.formDynamic.items[index-1])[this.languageKey.key5] = e.value+'';
                    (this.formDynamic.items[index-1])[this.languageKey.key3] = selItem.wordCode?selItem.wordCode+'' : '';
                    (this.formDynamic.items[index-1])[this.languageKey.key6] = selItem.wordCode? (this.pageId? this.pageId+'_'+selItem.wordCode+'' : '_'+selItem.wordCode+''):'';
                    (this.formDynamic.items[index-1])[this.languageKey.key1] = selItem.simpleChinese?selItem.simpleChinese+'' : '';
                    (this.formDynamic.items[index-1])[this.languageKey.key4] = selItem.englishText?selItem.englishText+'' : ''

                }else{
                    (this.formDynamic.items[index-1])[this.languageKey.key5] = '';
                    (this.formDynamic.items[index-1])[this.languageKey.key3] = '';
                    (this.formDynamic.items[index-1])[this.languageKey.key6] = '';
                    (this.formDynamic.items[index-1])[this.languageKey.key1] = '';
                    (this.formDynamic.items[index-1])[this.languageKey.key4] = ''
                }

               
            },
            handleSubmit (name) {
                // console.log('this.formDynamic.items',this.formDynamic.items)
                if(this.isGener){
                    return
                }
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        // console.log('this.formDynamic.items',this.formDynamic.items)
                        // const arr1 = this.formDynamic.items.map((item)=>item.status && item.LanguageKey)
                        const arr1 = this.formDynamic.items.filter((item)=>item.status).map((item1)=>item1.LanguageKey)
                        const arr2 = new Set(arr1)
                        if(arr2.size != arr1.length){
                            this.$Message.error(this.$t('BasicProduct.funcBox.titleName.LanguageKey')+'重复');
                            return
                        }
                        

                        const arr3 = this.formDynamic.items.filter((item)=>item.status).map((item1)=>item1.Code)
                        const arr4 = new Set(arr3)
                        if(arr3.length > arr4.size){
                            this.$Message.error('Code 重复');
                            return
                        }


                        const arr5 = this.formDynamic.items.filter((item)=>item.status).map((item1)=>item1[this.languageKey.key5])
                        const arr6 = new Set(arr5)
                        if(arr5.length > arr6.size){
                            this.$Message.error('词条 重复');
                            return
                        }



                        if(this.DataType =='8'){
                            let flag = 0
                            arr3.map(item=>{
                                if(!/^0[xX][0-9a-fA-F]+/.test(item)){
                                    flag = 1
                                }
                            })

                            // console.log('arr3',arr3)
                            // console.log('this.formDynamic.items',this.formDynamic.items)
                            if(flag){
                                this.$Message.error(this.$t('ruleCustom.16'));
                                return
                            }
                        }
                        //遍历数据，如果是新增，LanguageKey重复则提示
                        if(this.type==1){
                            let arr = this.editFormData.allArr
                            for(let i = 0;i< arr.length;i++){
                                if((arr[i])[0].LanguageKey==this.formDynamic.items[0].LanguageKey && (arr[i])[0].status){
                                   this.$Message.error('LanguageKey 与已存在列表重复')
                                   return
                                }
                            }
                        }


                        let emitArr = this.formDynamic.items.filter((item)=>{
                           return  item.status==1
                        }).map(item=>{
                            delete item.status
                            delete item.index
                            if(!item[this.languageKey.key6]){
                                item[this.languageKey.key6] = this.pageId? this.pageId+'_'+item[this.languageKey.key3]+'' : '_'+item[this.languageKey.key3]+''
                            }
                            return item
                        })
                        
                        this.fn(emitArr,this.descText)
               
                    } else {
                        this.$Message.error('Fail!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            },
            openOrClose(value) {
                if(value === true) {
                    this.getWordList();
                    if(Object.keys(this.editFormData).length>0){
                        // this.formDynamic.items = [...this.editFormData.IndentyName]
                        //  HexBoolean:{key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey',key5:'wordId',key6:'pageId_wordCode'},
                        // console.log('this.editFormData.IndentyName',this.editFormData.IndentyName)
                        // console.log('initdata',this.initdata)

                        
                        if(this.editFormData.IndentyName.length==2){// 新版本格式
                            this.formDynamic.items = [...JSON.parse(JSON.stringify(this.editFormData.IndentyName))]
                        }else if(this.editFormData.IndentyName.length==1){// 兼容旧版本格式

                            this.formDynamic.items[0]['Code']=this.DataType==9?'0x00':'False';
                            this.formDynamic.items[0]['Name-CN']=this.editFormData.IndentyName[0]['0x00-CN'] || this.editFormData.IndentyName[0]['False-CN'];
                            this.formDynamic.items[0]['Name-EN']=this.editFormData.IndentyName[0]['0x00-EN'] || this.editFormData.IndentyName[0]['False-EN'];
                            this.formDynamic.items[0]['LanguageKey']=this.editFormData.IndentyName[0]['0x00 LanguageKey'] || this.editFormData.IndentyName[0]['False LanguageKey'];
                            this.formDynamic.items[0]['wordId']=this.editFormData.IndentyName[0]['0x00 wordId'] || this.editFormData.IndentyName[0]['False wordId'];
                            this.formDynamic.items[0]['pageId_wordCode']=this.editFormData.IndentyName[0]['0x00 pageId_wordCode'] || this.editFormData.IndentyName[0]['False pageId_wordCode'];
                            this.formDynamic.items[0]['index']=1;
                            this.formDynamic.items[0]['status']=1;

                            this.formDynamic.items[1]['Code']=this.DataType==9?'0x01':'True';
                            this.formDynamic.items[1]['Name-CN']=this.editFormData.IndentyName[0]['0x01-CN'] || this.editFormData.IndentyName[0]['True-CN'];
                            this.formDynamic.items[1]['Name-EN']=this.editFormData.IndentyName[0]['0x01-EN'] || this.editFormData.IndentyName[0]['True-EN'];
                            this.formDynamic.items[1]['LanguageKey']=this.editFormData.IndentyName[0]['0x01 LanguageKey'] || this.editFormData.IndentyName[0]['True LanguageKey'];
                            this.formDynamic.items[1]['wordId']=this.editFormData.IndentyName[0]['0x01 wordId'] || this.editFormData.IndentyName[0]['True wordId'];
                            this.formDynamic.items[1]['pageId_wordCode']=this.editFormData.IndentyName[0]['0x01 pageId_wordCode'] || this.editFormData.IndentyName[0]['True pageId_wordCode'];
                            this.formDynamic.items[1]['index']=2;
                            this.formDynamic.items[1]['status']=1;


                            this.editFormData.IndentyName = JSON.parse(JSON.stringify([...this.formDynamic.items]))
                        }

                        // console.log(' this.formDynamic.items', this.formDynamic.items)

                        this.index = 1

                        if(this.type==2) {
                            this.index = this.editFormData.IndentyName.length
                        }
                    }
                }
            },
            getWordList(){
                let params={
                        page:1,
                        limit:100000,
                        pageId:this.pageId,
                        dealerId:this.selectId,
                    }
                this.wordListLoading = true
                this.axios.post(this.config.urlArray.pagesLangDictionaryList,params).then((result) => {
                    common.ajaxMsg(result.data,false,()=>{
                        let resData = result.data.data.dealersList
                        //处理数组
                        if(resData){
                            this.wordList = resData  //渲染数据
                            this.wordListLoading = false
                        }

                    });
                   
                }).catch((err) => {
                    // common.msg('error',err,()=>{})
                });
            },
            cancel() {//对话框关闭
                this.resetForm()
                // this.formDynamic.items = [...this.editFormData.IndentyName]
                this.$emit('update:showSetModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formDynamic.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>

<style lang="less" scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
        .ivu-select-dropdown {
            max-width: 250px;
        }
    }
     .ivu-modal-body {
        max-height: 800px;
         // overflow-y: scroll;
        overflow: auto;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
/deep/ .ivu-input[disabled]{
    background-color: #ffffff;
    color: #515a6e;
}
.delButton {
    /deep/ .ivu-form-item-content {
    margin-left: 20px !important;
}
}
</style>

